<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="addNew"
      >
        新增大区
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :pagination="showPagination"
        :columns="tableColumns"
        :dataSource="tableDataList"
        :rowSelection="rowSelection"
        :scroll="{ x: 900, y: 450 }"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            v-if="!record.status"
            type="primary"
            shape="round"
            size="small"
            @click.stop="handleSetStatus(record, 1)"
          >
            启用
          </a-button>
          <a-button
            v-if="record.status"
            type="dashed"
            shape="round"
            size="small"
            @click.stop="handleSetStatus(record, 0)"
          >
            禁用
          </a-button>

          <a-button
            type="dashed"
            shape="circle"
            title="添加子大区"
            size="small"
            @click.stop="handleAddSub(record)"
            >子</a-button
          >
          <a-button
            size="small"
            type="primary"
            shape="circle"
            icon="eye"
            title="查看大区详情"
          ></a-button>
          <a-button
            size="small"
            title="修改大区"
            type="primary"
            shape="circle"
            icon="edit"
            @click.stop="handleEdit(record)"
          ></a-button>
          <!-- 
          <a-button
            size="small"
            title="删除大区"
            type="danger"
            shape="circle"
            icon="delete"
          ></a-button>
          -->
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import updatePanel from "@/views/System/area/update.vue";

var num = 0;
var pageContext;
export default {
  name: "AreaList",
  computed: {
    platform_type: function() {
      return this.$store.state.user.role == 1 ? "sp" : "cp";
    },
    company_id: function() {
      return this.$store.state.user.companyId;
    }
  },
  data() {
    return {
      showPagination: false,
      tableColumns: [],
      tableDataList: [],
      rowSelection: {
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(selectedRowKeys);
        }
      }
    };
  },
  mounted() {
    pageContext = this;
    pageContext.initColumns();
    pageContext.refreshDataList();
  },
  methods: {
    initColumns() {
      pageContext.tableColumns = [
        {
          title: "名称",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "180px"
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: "100px"
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 230,
          scopedSlots: { customRender: "action" }
        }
      ];
    },
    async refreshDataList() {
      pageContext.$http
        .post("/area/getDataList", {
          platform_type: pageContext.platform_type,
          company_id: pageContext.company_id
        })
        .then(function(response) {
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    addNew() {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "新 增",
            platform_type: pageContext.platform_type,
            company_id: pageContext.company_id
          }
        },
        area: ["500px", "450px"],
        title: "新增大区",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        }
      });
    },
    handleEdit(record) {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "保 存",
            itemData: record
          }
        },
        area: ["500px", "450px"],
        title: "修改大区",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        }
      });
    },
    async handleSetStatus(record, status) {
      pageContext.$http
        .post("/area/setStatus", {
          id: record.id,
          status: status
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$message.success(response.data.msg);
            pageContext.refreshDataList();
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    handleAddSub(record) {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "添 加",
            pItemData: record
          }
        },
        area: ["500px", "550px"],
        title: "添加下级大区",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-circle {
    margin: 0px 5px;
  }
}
</style>
